import DesignSystemAppProvider from '@atlaskit/app-provider/app-provider';
import { FlagsProvider } from '@atlaskit/flag/flags-provider';
import type { ReactNode } from 'react';

import { CustomRouterLink } from '../../../common/components/custom-router-link';
import { FeatureGateClient } from '../../../controllers/feature-gates';
import { getThemePreference } from '../../../utils/color-theme';

export const BlockingAtlassianProviders = ({ children }: { children: ReactNode }) => {
	return (
		<DesignSystemAppProvider
			routerLinkComponent={CustomRouterLink}
			defaultColorMode={getThemePreference().colorMode}
		>
			<FeatureGateClient>
				<FlagsProvider>{children}</FlagsProvider>
			</FeatureGateClient>
		</DesignSystemAppProvider>
	);
};
